import { UserActionTypes, All } from '../actions/userActions';

export interface State {
  userById: any | null;
  action: String;
  errorMessage: string | null;
  successMessage: string | null;
  success : boolean,
  error: string | null;
  material;
}

const initialState: State =
{
  userById: null,
  action:'',
  errorMessage: null,
  successMessage: null,
  success: null,
  error:null,
  material:null
}

export function userReducer(state = initialState, action: All): State {
  switch (action.type) {
    case UserActionTypes.USER_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        userById: action.payload.data,
        success: action.payload.success,
        action : 'user' 
      };
    }
    case UserActionTypes.USER_FAILURE: {
      return {
        ...state,
        userById:null,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        action : 'user' 
      };
    }
    case UserActionTypes.MATERIAL_PROVIDER_SUCCESS: {
      return {
        ...state,
        errorMessage: null,
        successMessage: action.payload.successMessage,
        error: null,
        material: action.payload.data,
        success: action.payload.success,
        action : 'material' 
      };
    }
    case UserActionTypes.MATERIAL_PROVIDER_FAILURE: {
      return {
        ...state,
        userById:null,
        errorMessage: action.payload.error.message,
        error: action.payload.error.error !== undefined && action.payload.error.error.name || null,
        success: action.payload.error.success,
        action : 'material' 
      };
    }
    case UserActionTypes.EMAIL_SUCCESS: {
      return {
        ...state
      };
    }
    default: {
      return state;
    }
  }
}
